<template>
  <el-button
    :type="variant"
    v-bind="$attrs"
    :class="lg ? 'button-lg' : sm ? 'py-2 px-3' : 'py-2'"
    v-on="$listeners"
  >
    <font-awesome-icon
      v-if="iconLeft && icon"
      :icon="icon"
      :size="sizeIcon === 'lg' && sm ? null : sizeIcon"
      class="mr-2"
      :class="sm ? '' : lg ? '-ml-2' : '-ml-3'"
    />
    <template v-if="$slots.default">
      <slot />
    </template>
    <font-awesome-icon
      v-if="iconRight && icon"
      :icon="icon"
      :size="sizeIcon === 'lg' && sm ? null : sizeIcon"
      class="ml-2"
      :class="sm ? '' : lg ? '-mr-2' : '-mr-3'"
    />
  </el-button>
</template>

<script>
export default {
  name: 'YesButton',
  props: {
    variant: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    sizeIcon: {
      type: String,
      default: 'lg'
    },
    iconLeft: {
      type: Boolean,
      default: true
    },
    iconRight: {
      type: Boolean,
      default: false
    },
    lg: {
      type: Boolean,
      default: false
    },
    md: {
      type: Boolean,
      default: true
    },
    sm: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
